import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/components/Landing";
import Admin from "@/components/Admin";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import TermsAndConditions from "@/components/TermsAndConditions";
import Support from "@/components/Support";
import Trademarks from "@/components/Trademarks";
import StoreRedirect from "@/components/StoreRedirect";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/support" element={<Support />} />
          <Route path="/trademarks" element={<Trademarks />} />

          {/* Selah Downloads — short-links to app stores */}
          <Route
            path="/downloads/apple"
            element={<StoreRedirect gatewayId="selah-downloads" store="Apple" />}
          />
          <Route
            path="/downloads/android"
            element={<StoreRedirect gatewayId="selah-downloads" store="Google Play" />}
          />
          <Route
            path="/downloads/windows"
            element={<StoreRedirect gatewayId="selah-downloads" store="Windows" />}
          />

          {/* Selah Slate — short-links to app stores */}
          <Route
            path="/slate/apple"
            element={<StoreRedirect gatewayId="selah-slate" store="Apple" />}
          />
          <Route
            path="/slate/android"
            element={<StoreRedirect gatewayId="selah-slate" store="Google Play" />}
          />
          <Route
            path="/slate/windows"
            element={<StoreRedirect gatewayId="selah-slate" store="Windows" />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#F5E8E0",
            border: "1px solid rgba(63,84,104,0.35)",
            color: "#2a2622",
            fontFamily: "Montserrat, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
